<template>
  <div class="normalpaper">
    <div class="header">
      <div class="contain_main">
        <div class="logo">
          <img src="@/assets/header/logo.png" alt>
        </div>
        <div>
          <div class="button" @click="stock">题库导入</div>
          <div class="button" @click="issuestock=false;exceladd=true">Excel导入</div>
          <div class="button" @click="scan">预览</div>
          <div class="button" @click="addpaper">保存</div>
          <div class="button" @click="cancle">取消</div>
        </div>
      </div>
    </div>
    <div style="height:0.8rem;"></div>
    <div class="contain_main content">
      <div class="left">
        <div @click="make(1)">单选题</div>
        <div @click="make(2)">多选题</div>
        <div @click="make(4)">填空题</div>
        <div @click="make(3)">判断题</div>
        <div @click="make(5)">问答题</div>
        <!-- <div @click="make(0)">段落说明</div> -->
      </div>
      <div class="right">
        <div class="title">
          <span>
            试卷名称 ：
            <i-input type="text" style="width:200px" v-model="data.eptitle" placeholder="请输入试卷名称"></i-input>
          </span>
          <span>
            多选题少选得分:
            <i-Switch size="large" v-model="epdiff">
              <span slot="open">ON</span>
              <span slot="close">OFF</span>
            </i-Switch>
          </span>
          <span>
            试题数量 ：
            <i-input type="text" style="width:40px" disabled v-model="data.epcount"></i-input>
          </span>
          <span>
            试题总分 ：
            <i-input type="text" style="width:40px" disabled v-model="data.epscore"></i-input>
          </span>
          <!-- <span>是否有主观：{{data.epitem==0?"否":"是"}}</span> -->
        </div>
        <div class="smalltitle">
          <div class="questName">
            <div
              v-for="(item,index) in list"
              @click="changetab(index)"
              :key="'title'+index"
              :class="{questNameItem:true,act:tab==index}"
            >
              <input type="text" v-model="item.title" placeholder="输入大题名称">
              <span @click.stop="delissue(index)" v-if="list.length>1">
                <Icon type="md-close"/>
              </span>
            </div>
            <div @click="addissue" class="addbigquest">+</div>
          </div>
        </div>
        <div v-for="(item,index) in list" :key="'title'+index" v-show="index==tab">
          <div class="fillNumber">
            <span>
              当前选择共{{item.count}}题，随机抽题数目：
              <span style="margin-right:10px;">
                易
                <InputNumber
                  @on-change="numberChange"
                  v-model="item.easy"
                  style="width:50px;"
                  :max="item.class&&item.class[0]"
                  :min="0"
                ></InputNumber>
                /{{item.class?item.class[0]:'0'}}
              </span>
              <span style="margin-right:10px;">
                中
                <InputNumber
                  @on-change="numberChange"
                  v-model="item.normal"
                  style="width:50px"
                  :max="item.class&&item.class[1]"
                  :min="0"
                ></InputNumber>
                /{{item.class?item.class[1]:'0'}}
              </span>
              <span style="margin-right:10px;">
                难
                <InputNumber
                  @on-change="numberChange"
                  style="width:50px"
                  v-model="item.hard"
                  :max="item.class&&item.class[2]"
                  :min="0"
                ></InputNumber>
                /{{item.class?item.class[2]:'0'}}
              </span>
            </span>
            <span>
              该题分值：
              <InputNumber @on-change="numberChange" v-model="item.score" :min="0"></InputNumber>
            </span>
          </div>
          <makeissue
            v-for="(item,index) in item.questions"
            :key="item.questionid"
            :order="(index+1)"
            @complated="edit"
            @exit="exit"
            @delitem="delitem"
            @moveupitem="moveupitem"
            @movedownitem="movedownitem"
            @isedit="isedit"
            :message="item"
          />
        </div>
      </div>
    </div>
    <exceladd v-if="exceladd" @sure="sure" @close="close"></exceladd>
    <issuestock :haslist="haslist" @sure="sure" v-if="issuestock" @close="close"></issuestock>
  </div>
</template>
<script>
import makeissue from "../../components/makeissue";
import exceladd from "../../components/exceladd";
import issuestock from "../../components/issuestock";
import {
  ExamPaper_add2,
  ExamPaper_getInfo1,
  ExamPaper_update
} from "../../assets/js/api.js";
export default {
  data() {
    return {
      list: [
        {
          title: null,
          questions: [],
          hard: 0, //	string	true	普通参数		困难题目数
          normal: 0, //	string	true	普通参数		普通题目数
          easy: 0, //	string	true	普通参数		简单题目数
          count: 0, //	string	true	普通参数		大题题目数
          score: 0,
          class: null
        }
      ],
      exceladd: false,
      issuestock: false,
      epdiff: false,
      data: {
        epscore: "",
        epcount: "",
        epitem: 0,
        eptitle: "",
        epquestions: ""
      },
      tab: 0,
      haslist: []
    };
  },
  mounted() {
    if (this.$route.query.eptitle) {
      this.data.eptitle = this.$route.query.eptitle;
    }
    if (
      (this.$route.query.editid || this.$route.query.copyid) &&
      !this.$route.query.scan
    ) {
      this.getdata();
      // var query = { ...this.$route.query };
      // query.scan = true;
      // this.$router.push({
      //   path: "/manage/selectpaper",
      //   query: query
      // });
    } else {
      if (window.sessionStorage.getItem("selectpaperlist")) {
        this.list = JSON.parse(
          window.sessionStorage.getItem("selectpaperlist")
        );
      }
      for (var i = 0; i < this.list.length; i++) {
        this.list[i].questions = this.list[i].questions.map(item => {
          delete item.qbtitle;
          item.isedit = false;
          return item;
        });
      }
      this.numberChange();
    }
  },
  components: {
    makeissue,
    exceladd,
    issuestock
  },
  methods: {
    //题库导入
    stock() {
      if (this.checkisedit()) return;
      this.haslist = this.list.reduce((sum, item) => {
        return sum.concat(
          item.questions.map(sitem => {
            return sitem.questionid;
          })
        );
      }, []);
      this.exceladd = false;
      this.issuestock = true;
    },
    // 取消
    cancle() {
      window.sessionStorage.removeItem("selectpaperlist");
      // this.$router.go(-1);
      this.$router.push("/manage/publiclist");
    },
    // 添加大题
    addissue() {
      // 添加检查
      if (this.checkisedit()) return;
      var t = this.list[this.list.length - 1];
      if (!t.title) {
        this.errorPlus("大题名称不能为空");
        return;
      }
      if (!(t.easy + t.normal + t.hard)) {
        this.errorPlus("抽取数目不能为空");
        return;
      }
      if (!t.score) {
        this.errorPlus("该大题各小题统一分数不能为空");
        return;
      }
      this.list.push({
        title: null,
        questions: [],
        hard: 0,
        normal: 0,
        easy: 0,
        count: 0,
        score: 0,
        class: null
      });
    },
    delissue(index) {
      if (!confirm("您确定删除该大题，删除后将不做任何保存？")) return;
      this.list.splice(index, 1);
      this.tab = 0;
      this.changetab(0);
    },
    changetab(index) {
      if (this.checkisedit()) return;
      this.tab = index;
    },
    // 编辑试题部分-------
    exit(index) {
      // this.list = [];
      // this.$nextTick(() => {
      //   if (JSON.parse(window.sessionStorage.getItem("selectpaperlist"))) {
      //     this.list = JSON.parse(
      //       window.sessionStorage.getItem("selectpaperlist")
      //     );
      //   } else {
      //     this.list = [];
      //   }
      // });
      // alert(JSON.parse(window.sessionStorage.getItem("selectpaperlist"))[this.tab].questions.length)
      // if (JSON.parse(window.sessionStorage.getItem("selectpaperlist"))[this.tab].questions.length) {
      this.list = JSON.parse(window.sessionStorage.getItem("selectpaperlist"));
      // }
      this.list[this.tab].questions = this.list[this.tab].questions.map(
        item => {
          delete item.hasedit;
          item.isedit = false;
          return item;
        }
      );
    },
    numberChange() {
      this.data.epcount = this.list.reduce((sum, item) => {
        return (
          sum + Number(item.easy) + Number(item.normal) + Number(item.hard)
        );
      }, 0);
      this.data.epscore = this.list.reduce((sum, item) => {
        return (
          sum +
          (Number(item.easy) + Number(item.normal) + Number(item.hard)) *
            Number(item.score)
        );
      }, 0);
      this.setlist();
    },
    getdata() {
      ExamPaper_getInfo1({
        epid: this.$route.query.editid || this.$route.query.copyid
      }).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data.epquestions.map((item, index) => {
            item.easy = item.easy - 0;
            item.hard = item.hard - 0;
            item.normal = item.normal - 0;
            item.score = item.score - 0;
            item.class = item.class.map(item => item - 0);
            return item;
          });
          this.data.eptitle = res.data.data.eptitle;
          this.epdiff = res.data.data.epdiff == 1 ? true : false;
          this.data.epitem = res.data.data.epitem;
          this.numberChange();
          this.setlist();
        }
      });
    },
    // 缓冲加载
    loadact(data) {
      var t = data.length;
      if (10 * this.loaddata < t) {
        this.list = this.list.concat(
          data.slice(10 * this.loaddata, 10 * (this.loaddata + 1))
        );
        setTimeout(() => {
          this.loadact(data);
        }, 300);
        this.loaddata += 1;
      } else {
        this.numberScore();
        this.setlist();
        this.loaddata = 0;
      }
    },
    // 添加试题部分
    close() {
      this.exceladd = false;
      this.issuestock = false;
    },
    delitem(data) {
      this.list[this.tab].questions.splice(data, 1);
      // this.numberChange();
      var array = this.list[this.tab].questions;
      this.list[this.tab].class = [
        this.arraySum(array, 1),
        this.arraySum(array, 2),
        this.arraySum(array, 3)
      ];
      this.list[this.tab].count = this.arraySum(array, 0);
      this.setlist();
    },
    moveupitem(data) {
      if (data == 0) {
        this.errorPlus("已经在最顶部,无法上移!");
        return;
      }
      this.list[this.tab].questions[data - 1] = this.list[
        this.tab
      ].questions.splice(data, 1, this.list[this.tab].questions[data - 1])[0];
      this.setlist();
    },
    movedownitem(data) {
      if (data == this.list[this.tab].questions.length - 1) {
        this.errorPlus("已经在最底部,无法下移!");
        return;
      }
      this.list[this.tab].questions[data] = this.list[
        this.tab
      ].questions.splice(data + 1, 1, this.list[this.tab].questions[data])[0];
      this.setlist();
    },
    isedit(index, isedit) {
      this.list[this.tab].questions = this.list[this.tab].questions.map(
        item => {
          item.hasedit = true;
          return item;
        }
      );
      this.list[this.tab].questions[index].isedit = true;
    },
    checkisedit() {
      var check = this.list.some(item => {
        return item.questions.some(item => item.isedit);
      });
      if (check) {
        this.errorPlus("有题目在编辑状态,请完成编辑后操作!");
        return true;
      } else {
        return false;
      }
    },
    make(data) {
      if (this.checkisedit()) return;
      this.list[this.tab].questions.push({
        questiontype: data,
        isedit: true
      });
      this.list[this.tab].questions = this.list[this.tab].questions.map(
        item => {
          item.hasedit = true;
          return item;
        }
      );
      this.$nextTick(function() {
        window.scrollTo(0, document.documentElement.scrollHeight);
      });
    },
    edit(data, index) {
      this.list[this.tab].questions = this.list[this.tab].questions.map(
        item => {
          delete item.hasedit;
          item.isedit = false;
          return item;
        }
      );
      this.list[this.tab].questions[index - 1] = data;
      var array = this.list[this.tab].questions;
      this.list[this.tab].class = [
        this.arraySum(array, 1),
        this.arraySum(array, 2),
        this.arraySum(array, 3)
      ];
      this.list[this.tab].count = this.arraySum(array, 0);
      this.$set(this.list, this.tab, this.list[this.tab]);
      window.sessionStorage.setItem(
        "selectpaperlist",
        JSON.stringify(this.list)
      );
    },
    arraySum(array, condition) {
      return array.reduce((sum, item) => {
        if (condition ? item.questionlevel == condition : true) {
          return sum + 1;
        } else {
          return sum + 0;
        }
      }, 0);
    },
    sure(data) {
      this.list[this.tab].questions = this.list[this.tab].questions.concat(
        data
      );
      this.list[this.tab].questions = this.list[this.tab].questions.map(
        item => {
          delete item.qbtitle;
          item.isedit = false;
          return item;
        }
      );
      var array = this.list[this.tab].questions;
      this.list[this.tab].class = [
        this.arraySum(array, 1),
        this.arraySum(array, 2),
        this.arraySum(array, 3),
        this.arraySum(array, 0)
      ];
      this.list[this.tab].count = this.arraySum(array, 0);
      this.setlist();
      this.numberChange();
    },
    setlist() {
      window.sessionStorage.setItem(
        "selectpaperlist",
        JSON.stringify(this.list)
      );
    },
    addpaper() {
      if (this.checkisedit()) return;
      var t = this.list[this.list.length - 1];
      if (!t.title) {
        this.errorPlus("最后一道大题名称不能为空");
        return;
      }
      if (!(t.easy + t.normal + t.hard)) {
        this.errorPlus("最后一道大题抽取数目不能为空");
        return;
      }
      if (!t.score) {
        this.errorPlus("最后一道大题各小题统一分数不能为空");
        return;
      }
      if (!this.data.eptitle) {
        this.errorPlus("试卷名称不能为空");
        return;
      }
      if (this.data.eptitle && this.data.eptitle.length > 100) {
        this.errorPlus("试卷标题不能超过100字");
        return;
      }
      this.numberChange();
      this.data.epquestions = this.list;

      this.data.epitem = 1;
      this.data.epdiff = this.epdiff - 0;

      if (this.$route.query.editid) {
        this.data.epid = this.$route.query.editid;
        ExamPaper_update(this.data).then(res => {
          if (res.data.code == 200) {
            this.$Notice.success({ title: "成功提示", desc: "编辑保存成功！" });
            this.$router.push("/manage/publiclist");
            window.sessionStorage.removeItem("selectpaperlist");
            return;
          }
          this.$Notice.warning({ title: "信息提示", desc: res.data.message });
        });
      } else {
        ExamPaper_add2(this.data).then(res => {
          if (res.data.code == 200) {
            this.$Notice.success({ title: "成功提示", desc: "保存成功！" });
            this.$router.push("/manage/publiclist");
            window.sessionStorage.removeItem("selectpaperlist");
            return;
          }
          this.$Notice.warning({ title: "信息提示", desc: res.data.message });
        });
      }
    },
    scan() {
      var data = {
        scan: true
      };
      if (this.$route.query.editid) {
        data.editid = this.$route.query.editid;
      }
      if (this.data.eptitle) {
        data.eptitle = this.data.eptitle;
      }
      this.$router.push({
        path: "/manage/selectpaper",
        query: data
      });
      if (this.checkisedit()) return;
      if (!this.list.length) {
        this.errorPlus("请编辑或导入试题");
        return;
      }
      this.data.epquestions = this.list;
      this.$router.push({ name: "scanpaper", params: { message: this.data } });
    }
  }
};
</script>
<style lang="css" scoped>
.normalpaper {
  position: absolute;
  width: 100%;
  height: 100%;
}
.header {
  height: 0.8rem;
  text-align: left;
  border-bottom: #e8e9ee 1px solid;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 100;
}
.header .contain_main {
  display: flex;
  justify-content: space-between;
  line-height: 0.8rem;
}
.logo {
  width: 1.84rem;
  height: 0.4rem;
  line-height: 0.4rem;
  margin-top: 0.2rem;
}
.button {
  width: 0.9rem;
  height: 0.3rem;
  color: #fff;
  background: #4b51ff;
  line-height: 0.3rem;
  border-radius: 0.02rem;
  font-size: 0.14rem;
  text-align: center;
  display: inline-block;
  vertical-align: middle;
  margin: 0 0.15rem;
}
.headernull {
  height: 0.8rem;
}
.content {
  /* display: flex;
  justify-content: space-between; */
}
.left {
  width: 1rem;
  position: fixed;
  top: 0.8rem;
}
.right {
  width: 9rem;
  height: 100%;
  float: right;
}

.smalltitle {
  padding: 20px;
  /* margin-top: 30px; */
}
.questName {
  margin-top: 10px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.questNameItem {
  border-bottom: 2px solid #474dff;
  padding: 10px;
  background: #eff2f7;
  margin-right: 10px;
}
.questNameItem input {
  background: transparent;
  width: 100px;
}
.questNameItem.act {
  border-bottom: 2px solid #474dff;
  padding: 10px;
  background: #ccddff;
  color: #474dff;
  margin-right: 10px;
}
.questNameItem.act input {
  background: transparent;
  width: 100px;
  color: #474dff;
}

.questNameItem.act input::placeholder {
  color: #474dff;
}
.questNameItem .close {
  color: #bbb;
  margin-left: 10px;
}
.fillNumber {
  height: 50px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;
  margin: 0 20px 20px;
  align-items: center;
}
.addbigquest {
  width: 40px;
  background: #ffd6de;
  color: #ff064e;
  text-align: center;
  line-height: 45px;
  font-size: 28px;
  /* font-weight: bold; */
}
.left > div {
  height: 0.3rem;
  width: 1rem;
  margin: 0.1rem auto;
  color: #7b8b9f;
  line-height: 0.3rem;
  border-radius: 0.15rem;
  font-size: 0.16rem;
  background: #e9effa62;
  cursor: pointer;
}
.left > div:hover {
  background: #ccddff;
  color: #474dff;
}
.title {
  text-align: left;
  margin: 20px;
  display: flex;
  justify-content: space-between;
}
</style>


// WEBPACK FOOTER //
// src/pages/namnege/selectpaper.vue